import React from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styles from "./barAndLineComboChart.module.css";
import { format, getISOWeek } from "date-fns";

const CustomLegend = (props) => {
    const { payload } = props;
    return (
        <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
            {payload.map((entry, index) => {
                const { value, color } = entry;
                return (
                    <span
                        key={`item-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '0 10px',
                        }}
                    >
                        <span
                            style={{
                                backgroundColor: color,
                                width: '6px',
                                height: '12px',
                                display: 'inline-block',
                                borderRadius: '2px',
                            }}
                        />
                        <span style={{ color: '#4D4D4F' }}>{value}</span>
                    </span>
                );
            })}
        </div>
    );
};

const BarAndLineComboChart = ({ details, type, weekLabel }) => {
    const currentWeek = "Week " + getISOWeek(new Date());
    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'short' };
        const date = new Date(dateString.split('-').reverse().join('-'));
        return date.toLocaleDateString('en-US', options);
    };

    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split("-");
        return new Date(`${year}-${month}-${day}`);
    };

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    <span className={styles.toolTipLabel}>{label.includes('Week') ? label : `${format(parseDate(label), "d MMM")}`}</span>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span> : {`${item.value.toFixed(1)}`}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const tickFormatter = (tick) => {
        if (weekLabel.includes('-')) {
            return tick;
        } else {
            return formatDate(tick);
        }
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    }

    return (
        // <div className={styles.chartContainer}>
        <ResponsiveContainer width="100%" height={220}>
            <ComposedChart
                data={details}
                margin={{
                    top: 10,
                    right: 0,
                    bottom: 10,
                    left: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                <XAxis tickFormatter={tickFormatter} dataKey={weekLabel.includes('-') ? "Week" : "Date"} tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} />
                <YAxis domain={[0, 'auto']} tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} />
                <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{
                        fontSize: '12px',
                        padding: '6px',
                    }}
                />
                <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

                <Bar
                    radius={[4, 4, 0, 0]}
                    dataKey={(entry) => entry["Projected Demand"].value}
                    name="Projected Demand (bar)"
                    barSize={20}
                    fill="#005EEF"
                />
                <Bar
                    radius={(entry) =>
                        entry["P1 Alert - Demand vs Opening Stocks"] < 0 ? [0, 0, 0, 0] : [4, 4, 0, 0]
                    }
                    stackId="a"
                    dataKey={(entry) => weekLabel === currentWeek ? entry["Opening Stocks"] : entry["Projected Supply"].value}
                    name={weekLabel === currentWeek ? "Opening Stocks" : "Projected Supply (bar)"}
                    barSize={20}
                    fill="#00B190"
                />
                <Bar
                    radius={[4, 4, 0, 0]}
                    stackId="a"
                    dataKey={(entry) => weekLabel === currentWeek ?
                        (entry["P1 Alert - Demand vs Opening Stocks"] < 0 ? Math.abs(entry["P1 Alert - Demand vs Opening Stocks"]) : null) :
                        (entry["P1 Alert - Demand VS Projected Supply"] < 0 ? Math.abs(entry["P1 Alert - Demand VS Projected Supply"]) : null)}
                    name={weekLabel === currentWeek ? "P1 Alert - Demand vs Opening Stocks" : "P1 Alert - Demand VS Projected Supply"}
                    barSize={20}
                    fill="#FF544F"
                />
                <Line type="monotone" dataKey={(entry) => entry["Safety Norm"]} name="Safety Norm" stroke="#FEBF0F" fill="#FEBF0F" strokeWidth={1} />
            </ComposedChart>
        </ResponsiveContainer>
        // </div>
    );
}

export default BarAndLineComboChart;
